import type { ExperimentChecker } from "./ExperimentChecker";
import { checkExperiment, ribbonExperiments } from "./ribbonExperiments";

let minimumTargetSizesEnabled: boolean = false;
/**
 * Feature gate check to use WCAG 2.5.8 minimium target sizes.
 * This requires that all pointer input targets have at least a 24 CSS px diameter area
 * that does not overlap with any other adjacent target area.
 */
export const useMinimumTargetSizesIsEnabled = (context: ExperimentChecker) => {
  return (
    minimumTargetSizesEnabled ||
    !!checkExperiment(context, ribbonExperiments.minimumTargetSizesEnabled)
  );
};

export const setMinimumTargetSizesIsEnabled = (isEnabled: boolean) => {
  minimumTargetSizesEnabled = isEnabled;
};
